module.exports = __webpack_public_path__ + "img/search-el.c5af1f16.svg";